export class Constants {
  public static get AuthData(): string { return 'AppAuthData'; }
  public static get AuthDataMain(): string { return 'AppAuthDataMain'; }
  public static get InterceptorSkipHeader(): string { return 'X-Skip-Interceptor'; }
  public static get InterceptorFileHeader(): string { return 'X-File-Upload'; }
  // at least one uppercase, lowercase, special character.
  public static get PasswordPattern(): any { return /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!"#\$%&\'()\*+,\-./:;<=>?@\[\\\]\^_`{\|}~])/; }  
  public static get StashItTokenChannel(): string { return 'StashItTokenChannel'; }
  public static get LocationImageSize(): number { return 2097152; } // 2mb
  public static get DocumentFileSize(): number { return 10485760; } // 10mb
  public static get OneMb(): number { return 1048576; } // 1mb
  public static get TwoMb(): number { return 2097152; } // 2mb
  public static get OneKb(): number { return 1024; } // 1mb
  public static get EmailFooterImageSize(): number { return 563200; } // 550KB
  public static get ImageExtension(): any { return /.(jpg|jpeg|png|bmp|tif|gif)$/i; }
  public static get DocumentExtension(): any { return /.(pdf)$/i; }
  public static get ZipCodeRegex(): any { return /(^\d{5}(?:[\s]?[-\s][\s]?\d{4})?$)/; }
  public static get SsnRegex(): any { return /^(?!219-09-9999|078-05-1120)(?!666|000|9\d{2})\d{3}-(?!00)\d{2}-(?!0{4})\d{4}$/; }
  public static get NumberRegex(): any { return /^-?[\d.]+(?:e-?\d+)?$/; }
  public static get DateRegex(): any { return /^([0-9]{1,2})\/([0-9]{1,2})\/([0-9]{4})$/; }
  public static get DollarAmountRegex(): any { return /^-?(?:\d+|\d{1,3}(?:,\d{3})+)(?:(\.|,)\d+)?$/; }
  public static get DateFormat(): any { return 'MM/dd/yyyy'; }
  public static get DeleteConfirmModal(): string { return 'DeleteConfirmModal'; }
  public static get NewInvoiceFormatDate(): string { return '2022/01/01'; }
}

export class LoanClosingFeeSectionConstants {
  public static get SectionA(): string { return 'sectionA'; }
  public static get SectionB(): string { return 'sectionB'; }
  public static get BoxJ(): string { return 'boxJ'; }
  public static get BoxF(): string { return 'boxF'; }
  public static get Warehouse(): string { return 'warehouse'; }
  public static get InvestorCharges(): string { return 'investorCharges'; }
}

export class DistributionRoleConstants {
  public static get LoanOfficer(): number { return 0; }
  public static get Processor(): number { return 1; }
  public static get Funder(): number { return 2; }
}

export const permissionActions: string[] = ["Read", "Write", "Delete"];